import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../wayfinder'
/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:14
* @route '//tallied.art'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '//tallied.art',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:14
* @route '//tallied.art'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:14
* @route '//tallied.art'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:14
* @route '//tallied.art'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:14
* @route '//tallied.art'
*/
const homeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:14
* @route '//tallied.art'
*/
homeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:14
* @route '//tallied.art'
*/
homeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

home.form = homeForm

/**
* @see \App\Http\Controllers\ChangelogController::__invoke
* @see app/Http/Controllers/ChangelogController.php:24
* @route '//tallied.art/changelog'
*/
export const changelog = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: changelog.url(options),
    method: 'get',
})

changelog.definition = {
    methods: ["get","head"],
    url: '//tallied.art/changelog',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ChangelogController::__invoke
* @see app/Http/Controllers/ChangelogController.php:24
* @route '//tallied.art/changelog'
*/
changelog.url = (options?: RouteQueryOptions) => {
    return changelog.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ChangelogController::__invoke
* @see app/Http/Controllers/ChangelogController.php:24
* @route '//tallied.art/changelog'
*/
changelog.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: changelog.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ChangelogController::__invoke
* @see app/Http/Controllers/ChangelogController.php:24
* @route '//tallied.art/changelog'
*/
changelog.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: changelog.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ChangelogController::__invoke
* @see app/Http/Controllers/ChangelogController.php:24
* @route '//tallied.art/changelog'
*/
const changelogForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: changelog.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ChangelogController::__invoke
* @see app/Http/Controllers/ChangelogController.php:24
* @route '//tallied.art/changelog'
*/
changelogForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: changelog.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ChangelogController::__invoke
* @see app/Http/Controllers/ChangelogController.php:24
* @route '//tallied.art/changelog'
*/
changelogForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: changelog.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

changelog.form = changelogForm

/**
* @see \App\Http\Controllers\Marketing\SitemapController::__invoke
* @see app/Http/Controllers/Marketing/SitemapController.php:20
* @route '//tallied.art/sitemap.xml'
*/
export const sitemap = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sitemap.url(options),
    method: 'get',
})

sitemap.definition = {
    methods: ["get","head"],
    url: '//tallied.art/sitemap.xml',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Marketing\SitemapController::__invoke
* @see app/Http/Controllers/Marketing/SitemapController.php:20
* @route '//tallied.art/sitemap.xml'
*/
sitemap.url = (options?: RouteQueryOptions) => {
    return sitemap.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Marketing\SitemapController::__invoke
* @see app/Http/Controllers/Marketing/SitemapController.php:20
* @route '//tallied.art/sitemap.xml'
*/
sitemap.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sitemap.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Marketing\SitemapController::__invoke
* @see app/Http/Controllers/Marketing/SitemapController.php:20
* @route '//tallied.art/sitemap.xml'
*/
sitemap.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: sitemap.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Marketing\SitemapController::__invoke
* @see app/Http/Controllers/Marketing/SitemapController.php:20
* @route '//tallied.art/sitemap.xml'
*/
const sitemapForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sitemap.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Marketing\SitemapController::__invoke
* @see app/Http/Controllers/Marketing/SitemapController.php:20
* @route '//tallied.art/sitemap.xml'
*/
sitemapForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sitemap.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Marketing\SitemapController::__invoke
* @see app/Http/Controllers/Marketing/SitemapController.php:20
* @route '//tallied.art/sitemap.xml'
*/
sitemapForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sitemap.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

sitemap.form = sitemapForm

/**
* @see \App\Http\Controllers\WellKnown\SecurityTxtController::__invoke
* @see app/Http/Controllers/WellKnown/SecurityTxtController.php:28
* @route '//tallied.art/.well-known/security.txt'
*/
export const securityTxt = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: securityTxt.url(options),
    method: 'get',
})

securityTxt.definition = {
    methods: ["get","head"],
    url: '//tallied.art/.well-known/security.txt',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WellKnown\SecurityTxtController::__invoke
* @see app/Http/Controllers/WellKnown/SecurityTxtController.php:28
* @route '//tallied.art/.well-known/security.txt'
*/
securityTxt.url = (options?: RouteQueryOptions) => {
    return securityTxt.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WellKnown\SecurityTxtController::__invoke
* @see app/Http/Controllers/WellKnown/SecurityTxtController.php:28
* @route '//tallied.art/.well-known/security.txt'
*/
securityTxt.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: securityTxt.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WellKnown\SecurityTxtController::__invoke
* @see app/Http/Controllers/WellKnown/SecurityTxtController.php:28
* @route '//tallied.art/.well-known/security.txt'
*/
securityTxt.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: securityTxt.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\WellKnown\SecurityTxtController::__invoke
* @see app/Http/Controllers/WellKnown/SecurityTxtController.php:28
* @route '//tallied.art/.well-known/security.txt'
*/
const securityTxtForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: securityTxt.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WellKnown\SecurityTxtController::__invoke
* @see app/Http/Controllers/WellKnown/SecurityTxtController.php:28
* @route '//tallied.art/.well-known/security.txt'
*/
securityTxtForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: securityTxt.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WellKnown\SecurityTxtController::__invoke
* @see app/Http/Controllers/WellKnown/SecurityTxtController.php:28
* @route '//tallied.art/.well-known/security.txt'
*/
securityTxtForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: securityTxt.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

securityTxt.form = securityTxtForm

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
loginForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
loginForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

login.form = loginForm

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
const logoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logoutForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

logout.form = logoutForm

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
export const register = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

register.definition = {
    methods: ["get","head"],
    url: '/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: register.url(options),
    method: 'head',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
const registerForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
registerForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
registerForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

register.form = registerForm

/**
* @see routes/tenant.php:57
* @route '/impersonate/{token}'
*/
export const impersonate = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: impersonate.url(args, options),
    method: 'get',
})

impersonate.definition = {
    methods: ["get","head"],
    url: '/impersonate/{token}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/tenant.php:57
* @route '/impersonate/{token}'
*/
impersonate.url = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { token: args }
    }

    if (Array.isArray(args)) {
        args = {
            token: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        token: args.token,
    }

    return impersonate.definition.url
            .replace('{token}', parsedArgs.token.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see routes/tenant.php:57
* @route '/impersonate/{token}'
*/
impersonate.get = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: impersonate.url(args, options),
    method: 'get',
})

/**
* @see routes/tenant.php:57
* @route '/impersonate/{token}'
*/
impersonate.head = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: impersonate.url(args, options),
    method: 'head',
})

/**
* @see routes/tenant.php:57
* @route '/impersonate/{token}'
*/
const impersonateForm = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: impersonate.url(args, options),
    method: 'get',
})

/**
* @see routes/tenant.php:57
* @route '/impersonate/{token}'
*/
impersonateForm.get = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: impersonate.url(args, options),
    method: 'get',
})

/**
* @see routes/tenant.php:57
* @route '/impersonate/{token}'
*/
impersonateForm.head = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: impersonate.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

impersonate.form = impersonateForm

/**
* @see \App\Http\Controllers\Search\SearchController::__invoke
* @see app/Http/Controllers/Search/SearchController.php:21
* @route '/search'
*/
export const search = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: search.url(options),
    method: 'get',
})

search.definition = {
    methods: ["get","head"],
    url: '/search',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Search\SearchController::__invoke
* @see app/Http/Controllers/Search/SearchController.php:21
* @route '/search'
*/
search.url = (options?: RouteQueryOptions) => {
    return search.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Search\SearchController::__invoke
* @see app/Http/Controllers/Search/SearchController.php:21
* @route '/search'
*/
search.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Search\SearchController::__invoke
* @see app/Http/Controllers/Search/SearchController.php:21
* @route '/search'
*/
search.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: search.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Search\SearchController::__invoke
* @see app/Http/Controllers/Search/SearchController.php:21
* @route '/search'
*/
const searchForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Search\SearchController::__invoke
* @see app/Http/Controllers/Search/SearchController.php:21
* @route '/search'
*/
searchForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Search\SearchController::__invoke
* @see app/Http/Controllers/Search/SearchController.php:21
* @route '/search'
*/
searchForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: search.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

search.form = searchForm
